import React from "react";
import styled from "styled-components";
import Stars from "src/react/components/stars";
import { color } from "src/styles/variables";

const reviews = [
  {
    review:
      "I love cornerstone, you supply great quality products straight to my door. It’s affordable with great customer service.",
    author: "Ewan Boyce",
  },
  {
    review:
      "Easy to use website that allows orders to be tailored to your needs. Great prices too.",
    author: "Angela James",
  },
  {
    review:
      "From order to delivery it was very quick. No hassles and very nicely presented products. The regular emails and updates are a good source of information too.",
    author: "Graeme Lindsay",
  },
];

function MembersReviews() {
  return (
    <Wrapper>
      <Title>Proudly powered by our members</Title>
      <p>
        From our first crowdfunding to today, we include our members' feedback
        every step of the way to improve our service and launch new products.
      </p>
      <Reviews>
        {reviews.map((review, index) => (
          <Review key={`review-${index}`} column>
            <Stars value={5} size={30} style={{ display: "inline-block" }} />
            <Description>{review.review}</Description>
            <Author>- {review.author}</Author>
          </Review>
        ))}
      </Reviews>
    </Wrapper>
  );
}

export default MembersReviews;

const Wrapper = styled.section`
  text-align: center;
  padding: 40px 20px 20px;
  background-color: ${color.lightGrey};
`;

const Reviews = styled.div`
  margin-top: 20px;
  display: flex;
  @media (max-width: 899px) {
    flex-direction: column;
    align-items: center;
  }
  justify-content: center;
`;

const Review = styled.div`
  font-size: 14px;
  font-weight: 400;
  margin: 10px auto 20px;
  max-width: 400px;
  @media (min-width: 700px) {
    margin-right: 15px;
    margin-left: 15px;
    margin-bottom: 10px;
  }
`;

const Description = styled.p`
  margin-top: 5px;
  margin-bottom: 10px;
  position: relative;
`;

const Author = styled.p`
  font-size: 12px;
  font-weight: 600;
`;

const Title = styled.h2`
  font-size: 28px;
  @media (min-width: 700px) {
    font-size: 36px;
  }
  font-weight: 600;
  margin-bottom: 10px;
`;
